export default __webpack_public_path__ + "static/experienceImg1-6dbfc157f945a0ad30094fc8f6ac0fbf.webp";